import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/sms`;

export const smsHandlers = [
  // SMS検証コード送信依頼
  http.post(`${baseUrl}/send_request`, async ({ request }) => {
    const { country_code, phone_number } = (await request.json()) as Required<{
      country_code: string;
      phone_number: string;
    }>;

    if (country_code === '000') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'country_code',
              message: '国番号が不正です',
            },
          ],
        },
        { status: 400 }
      );
    } else if (phone_number === '999999999') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'phone_number',
              message: '電話番号が不正です',
            },
          ],
        },
        { status: 400 }
      );
    }

    return HttpResponse.json({ success: true });
  }),
  // SMS検証
  http.post(`${baseUrl}/verify`, async ({ request }) => {
    const { code } = (await request.json()) as Required<{
      code: string;
    }>;
    if (code === '000000') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'code',
              message: '認証コードが正しくありません',
            },
          ],
        },
        { status: 400 }
      );
    } else {
      return HttpResponse.json({ success: true });
    }
  }),
  // SMS検証済
  http.get(`${baseUrl}/is_verified`, async () => {
    return HttpResponse.json({ verified: false });
  }),
];
